import { useOnboardingStore } from '../../../store/onboardingStore';
import { Tag } from 'lucide-react';
import { dictionary } from '../../../utils/dictionary';
import { useAuth } from '../../../context/AuthContext';

// Helper function to truncate text by word count
const truncateWords = (text: string, wordCount: number) => {
  if (!text) return '';
  const words = text.split(' ');
  if (words.length <= wordCount) return text;
  return words.slice(0, wordCount).join(' ') + '...';
};

export function ProductCard() {
  const { data } = useOnboardingStore();
  const { productData, visualContent } = data;
  const { language } = useAuth();
  
  // Get the product image or a placeholder
  const productImage = visualContent.images.length > 0 
    ? visualContent.images[0] 
    : visualContent.imagesBase64.length > 0
      ? visualContent.imagesBase64[0]
      : 'https://placehold.co/400x400/e2e8f0/64748b?text=No+Image';

  // Truncate product details for the summary
  const truncatedDetails = productData.details && productData.details.length > 100 
    ? `${productData.details.substring(0, 100)}...` 
    : productData.details;

  // Format warranty text
  const getWarrantyText = () => {
    switch (productData.warranty) {
      case '30days': return dictionary["30-days-warranty"][language];
      case '90days': return dictionary["90-days-warranty"][language];
      case 'custom': return dictionary["custom-warranty"][language];
      default: return null;
    }
  };

  const warrantyText = getWarrantyText();

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-3 shadow-sm">
      <div className="flex items-center space-x-3">
        <div className="flex-shrink-0 w-14 h-14 rounded-md overflow-hidden bg-gray-100">
          <img 
            src={productImage} 
            alt={productData.name || "Product"} 
            className="w-full h-full object-cover"
          />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between">
            <h3 className="text-base font-medium text-gray-900 truncate">
              {truncateWords(productData.name, 8)}
            </h3>
          </div>
          <p className="text-xs text-gray-500 line-clamp-1 mt-0.5">
            {truncateWords(truncatedDetails, 15)}
          </p>
          <div className="flex items-center mt-1 space-x-2">
            {productData.freeShipping && (
              <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-700">
                {dictionary["free-shipping"][language]}
              </span>
            )}
            {warrantyText && (
              <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-700">
                <Tag className="w-3 h-3 mr-1" />
                {warrantyText}
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}